import * as angular from "angular";

angular.module("adminDependencies", [
    "ngRoute",
    "ngCookies",
    "ngResource",
    "ngSanitize",
    "ngMaterial",
    "admin",
    "map",
    "organisation",
    "campaign",
    "filters",
    "credentialsManager",
    "requestInterceptor",
    "subscription",
    "notification",
    "navigation",
    "general",
    "pageHeading",
    "ecanvasserDirectives",
    "team",
    "talkingPoint",
    "user",
    "activity",
    "filter",
    "permission",
    "invite",
    "house",
    "houseoccupant",
    "document",
    "group",
    "voterFile",
    "vcHelper",
    "vcServices",
    "vcDataProvider",
    "adminTheme",
    "md.data.table",
    "fixed.table.header",
    "dndLists",
    "table",
]);
